import { extractNftsInfo, groupHotNfts } from './extractNfts';
import { nap } from '../../../generalUtils/utils';
import { get } from 'lodash';
import { isLocal } from '../../../constants/envs';
import { fetchFromAny } from './atomicApi';
import { authFlowDebug } from '../../../debug/authFlowDebug';


export const fetchInventory = async (waxAccountName) => {
  try {
    authFlowDebug('fetchInventory.wax.start', { waxAccountName });
    const params = `?collection_name=crypto4shots&owner=${waxAccountName}&page=1&limit=100&order=desc&sort=asset_id`;
    const { data } = await fetchFromAny(`/atomicassets/v1/assets${params}`);
    authFlowDebug('fetchInventory.wax.page.done', {
      waxAccountName,
      page: 1,
      rawNftsCount: data && data.length,
      responseOwner: get(data, '[0].owner'),
    });
    let nftsArr = data;
    if (nftsArr.length === 0) {
      // const isOk = window.confirm('It looks like you dont have the NFTs required to play. Want to purchase them from AtomicHub?');
      // if (isOk) window.open('https://wax.atomichub.io/market?collection_name=crypto4shots&order=asc&schema_name=cs.startpack&sort=price&symbol=WAX', '_blank');
    }
    const responseOwner = get(data, '[0].owner');
    if (responseOwner && responseOwner !== waxAccountName) {
      console.error('Account mismatch:', responseOwner, waxAccountName);
      authFlowDebug('fetchInventory.wax.accountMismatch', {
        waxAccountName,
        responseOwner,
      });
      nftsArr = []; // need to empty because otherwise it has another account data (yeh wtf)
    }
    const { currentAssets, ignoredItems } = extractNftsInfo({ nftsArr, waxAccountName });
    let additionalCsAssets = [];
    let additionalIgnored = [];
    console.debug(`CS NFTs in reply: ${nftsArr.length}`);
    if (nftsArr.length === 100) {
      await nap(500);
      const { err, res } = await fetchAdditionalPages({ page: 2, waxAccountName }); // eslint-disable-line no-use-before-define
      if (err) return ({ err });
      additionalCsAssets = res.additionalCsAssets;
      additionalIgnored = res.additionalIgnored;
    }
    const csNfts = [...currentAssets, ...additionalCsAssets];
    const hotNfts = groupHotNfts([...ignoredItems, ...additionalIgnored]);
    console.debug(`Unique NFT types in cooldown: ${Object.keys(hotNfts).length}`);
    authFlowDebug('fetchInventory.wax.done', {
      waxAccountName,
      waxNftsCount: csNfts.length,
      ignoredItemsCount: ignoredItems.length + additionalIgnored.length,
      hotNftsCount: Object.keys(hotNfts).length,
    });
    return ({ csNfts, hotNfts });
  } catch (err) {
    console.error('Inventory fetch failed:', err);
    authFlowDebug('fetchInventory.wax.error', {
      waxAccountName,
      errMessage: err && err.message,
    });
    return { err };
  }
};

const fetchAdditionalPages = async ({ page, waxAccountName }) => {
  console.debug(`Fetching page ${page} for ${waxAccountName}'s assets`);
  try {
    authFlowDebug('fetchInventory.wax.additionalPage.start', { waxAccountName, page });
    const params = `?collection_name=crypto4shots&owner=${waxAccountName}&page=${page}&limit=100&order=desc&sort=asset_id`;
    const { data: nftsArr } = await fetchFromAny(`/atomicassets/v1/assets${params}`);
    let additionalCsAssets = [];
    let additionalIgnored = [];
    if (nftsArr.length === 100) {
      if (page === 51) return ({ err: 'More than 5000 NFTs???' });
      await nap(500);
      const { err, res } = await fetchAdditionalPages({ page: page + 1, waxAccountName });
      if (err) return ({ err });
      additionalCsAssets = res.additionalCsAssets;
      additionalIgnored = res.additionalIgnored;
    }
    const { currentAssets, ignoredItems } = extractNftsInfo({ nftsArr, waxAccountName });
    console.debug(`Page ${page} of NFTs:`, currentAssets.length);
    authFlowDebug('fetchInventory.wax.additionalPage.done', {
      waxAccountName,
      page,
      rawNftsCount: nftsArr.length,
      currentAssetsCount: currentAssets.length,
      ignoredItemsCount: ignoredItems.length,
    });
    const csNfts = [...currentAssets, ...additionalCsAssets];
    return ({ res: {
      additionalCsAssets: csNfts,
      additionalIgnored: [...ignoredItems, ...additionalIgnored],
    } });
  } catch (err) {
    console.error(`WAX NFTs read error for page ${page}:`, err);
    authFlowDebug('fetchInventory.wax.additionalPage.error', {
      waxAccountName,
      page,
      errMessage: err && err.message,
    });
    return ({ err });
  }
};


// ALTERNATIVE WAY OF FETCHING NFTS ---------------------------------------------------

const { ExplorerApi } = require('atomicassets'); // NFTs lookup!

// https://test.wax.api.atomicassets.io
const nftsLookupNodes = [
  'https://wax.api.atomicassets.io',
];

let nftsClient;

// https://www.npmjs.com/package/atomicassets
const getNFTsClient = () => {
  if (nftsClient && Math.random() > 0.5) return nftsClient;
  const randId = Math.floor(Math.random() * nftsLookupNodes.length);
  const waxNode = nftsLookupNodes[randId];
  nftsClient = new ExplorerApi(waxNode, 'atomicassets', { fetch });
  return nftsClient;
};
window.getNFTsClient = getNFTsClient; // TEMP

// #### NFTS LOOKUP

const fetchWaxNfts = async ({ waxAddr }) => {
  isLocal && console.log('Loading nft asset_ids for wallet', waxAddr);
  const api = getNFTsClient();
  const waxNfts = await api.getAssets({ owner: waxAddr });
  isLocal && console.log('Fetched::::', JSON.stringify(waxNfts[0], null, 2));
  return ({ waxNfts });
};
